import styled from "styled-components";

export const TableContainer = styled.div`
    width: 100%;
    flex: 1;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    min-height: 0;
`

export const StyledTableZone = styled.div`
  max-width: calc(100vw - 20px);
  display: flex;
  flex: 1;
  flex-flow: column;
  overflow: auto;
  padding: 1.5rem;
  margin: 10px 1rem;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 10px;
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 10px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #00000060;
    border-radius: 10px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #00000060;
  }
`


export const StyledActionsZone = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding: 10px 1rem;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 20px;
`

export const StyledActionsSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  gap: 20px;
`

export const StyledActionsSectionCenter = styled(StyledActionsSection)`
  flex-wrap: wrap;
`

export const StyledActionsSectionRight = styled(StyledActionsSection)`
  justify-content: flex-end;
`
